export default {
  data() {
      return {
          broadcastChannel: null
      }
  },
  created() {
      this.broadcastChannel = new BroadcastChannel('mytodo-channel');
  },
  destoryed() {
   if(this.broadcastChannel) {
      this.broadcastChannel.close();
   }   
  }
}